<div *ngIf="value != null" class="container">
    <ng-container *ngIf="optionExpanded=='' || optionExpanded==null">
        <div class="info-partner police">
            <i class="hardman-inspector" aria-hidden="true"></i>
            {{ 'SHARED.EXTERNAL.CMR.AGENT.POLICE.TITLE' | translate }}
        </div>
        <shared-ecmrs-qr-component [qrdownload]="true" [uuidQR]="uuidQR" [helpResource]="'SHARED.QR.CMR.HELP'"></shared-ecmrs-qr-component>

        <div class="route-description">
            {{'SHARED.EXTERNAL.CMRS.TITLE' | translate:{ value: getCount() } }}
        </div>
        <div class="buttons-group">
            <div class="action-card card-documents" (click)="onClickLinkOption('Goods')">
                <div class="icon-wrapper">
                    <i class="hardman-pallet" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ getResourceGoods() | translate:{ value: getCount() } }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <div class="action-card card-documents" (click)="onClickLinkOption('ControlDocument')">
                <div class="icon-wrapper">
                    <i class="fa fa-file-text" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ getResourceControlDocument() | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <div class="action-card card-comment" (click)="onClickLinkOption('CreateEvent')">
                <div class="icon-wrapper">
                    <i class="fa fa-comment" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ 'SHARED.EXTERNAL.CMR.ACTIONS.CREATEEVENT.CAPTION' | translate }}</div>
                    <div class="card-desc">{{ 'SHARED.EXTERNAL.CMR.ACTIONS.CREATEEVENT.POLICE.HELP' | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
        </div>
    </ng-container>
    <shared-external-cmr-agent-listcmrs *ngIf="optionExpanded=='ControlDocument'" [uuidQR]="uuidQR" [agent]="'police'"></shared-external-cmr-agent-listcmrs>
    <shared-external-cmr-agent-goods *ngIf="optionExpanded=='Goods'" [uuidQR]="uuidQR" [agent]="'police'"></shared-external-cmr-agent-goods>
    <shared-external-cmr-agent-actions-newevent *ngIf="optionExpanded=='CreateEvent'" [uuidQR]="uuidQR"
        [agent]="'police'"></shared-external-cmr-agent-actions-newevent>
</div>